import styled from "styled-components";
import { transparentize } from "polished";
import {
  MdBrightness1 as CloseCircle,
  MdPanoramaFishEye as OpenCircle
} from "react-icons/md";

export const InactiveIcon = styled(OpenCircle)`
  height: 8px;
  width: 8px;
  padding: 8px;
  cursor: pointer;
  user-select: none;
  color: ${({ theme }) =>
    theme.darkMode ? transparentize(0.4, theme.textOnPrimary) : theme.primary};
  outline: none;
  vertical-align: middle;

  &:hover {
    path {
      stroke-width: 2;
    }
  }

  path {
    stroke: ${({ theme }) =>
      theme.darkMode
        ? transparentize(0.4, theme.textOnPrimary)
        : theme.primary};
    stroke-width: 4;
  }
`;

export const ActiveIcon = styled(CloseCircle)`
  height: 8px;
  width: 8px;
  padding: 8px;
  cursor: pointer;
  user-select: none;
  position: absolute;
  color: ${({ theme }) =>
    theme.darkMode ? transparentize(0.4, theme.textOnPrimary) : theme.primary};
  ${({ side }: { side: string }) => side === "right" && "right: 0;"};
`;
